export const ADD_SNACKBAR = 'SET_SNACKBAR';
export const REMOVE_SNACKBAR = 'DROP_SNACKBAR';
export const REMOVE_ALL_SNACKBAR = 'REMOVE_ALL_SNACKBAR';
